import { Toaster } from './toast';

export class ErrorHandler {
  public static errorResponseHandler(error: any) {
    const isSystemError = error.response.status === 500;
    // const message = isSystemError ? 'حدث خطا ما في النظام' : error.response.data.errorMessage;

    window.HideLoader();

    if (isSystemError) {
      Toaster.error({ message: 'حدث خطا ما في النظام' });
    }

    return Promise.reject(error);
  }
}
